import { z } from 'zod'

import { createCustomerDisplayEventSchemas } from './customer-display-event-schemas'

export function createCustomerDisplayStateSchema() {
    const events = createCustomerDisplayEventSchemas()
    const metadata = {
        revision: z.number().nonnegative().refine(Number.isInteger),
        updated_at: z.iso.datetime({ offset: true }).nullable(),
        expires_at: z.iso.datetime({ offset: true }).nullable(),
        server_time: z.iso.datetime({ offset: true }),
    }
    return z.discriminatedUnion('type', [
        z.object({
            ...metadata,
            type: z.literal('cart'),
            data: events.customer_display_cart,
        }),
        z.object({
            ...metadata,
            type: z.literal('checkout'),
            data: events.customer_display_checkout,
        }),
        z.object({
            ...metadata,
            type: z.literal('qr'),
            data: events.customer_display_qr,
        }),
        z.object({
            ...metadata,
            type: z.literal('paid'),
            data: events.customer_display_paid,
        }),
        z.object({
            ...metadata,
            type: z.literal('clear'),
            data: events.customer_display_clear,
        }),
    ])
}

export type CustomerDisplaySnapshot = z.infer<
    ReturnType<typeof createCustomerDisplayStateSchema>
>
